import { useMemo } from 'react'

import { f0FormField, useF0FormDefinition } from '@factorialco/f0-react'
import { FactorialF0Form } from 'modules/core/components/FactorialF0Form'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

export type TemplateSettingsFormValues = {
  title: string
  description?: string
  anonymous?: boolean
}

const useTemplateSettingsSchema = () => {
  return useMemo(
    () =>
      z.object({
        title: f0FormField(z.string().min(1), {
          label: i18n.t('common.title'),
        }),
        description: f0FormField(z.string().optional(), {
          label: i18n.t('common.description'),
          fieldType: 'textarea',
          rows: 3,
        }),
      }),
    []
  )
}

interface Props {
  defaultValues: Partial<TemplateSettingsFormValues>
  onSubmit: (values: TemplateSettingsFormValues) => Promise<{ success: boolean }>
}

const TemplateSettingsForm = ({ defaultValues, onSubmit }: Props) => {
  const schema = useTemplateSettingsSchema()

  const submitConfig = useMemo(
    () => ({
      type: 'action-bar' as const,
      label: i18n.t('common.save'),
      discardable: true,
      centerActionBarInFrameContent: true,
    }),
    []
  )

  const formDefinition = useF0FormDefinition({
    name: 'template-settings',
    schema,
    defaultValues,
    submitConfig,
    onSubmit: ({ data }) => onSubmit(data),
  })

  return <FactorialF0Form formDefinition={formDefinition} className="mx-auto" />
}

export default TemplateSettingsForm
